/* "New framework" PDP: slider arrows and in-view video playback. */
(function () {
  if (window.__nfPdpInit) return;
  window.__nfPdpInit = true;

  function initSlider(slider) {
    if (slider.dataset.nfReady) return;
    slider.dataset.nfReady = '1';
    var track = slider.querySelector('.nf-track');
    if (!track) return;
    var prev = slider.querySelector('.nf-arrow--prev');
    var next = slider.querySelector('.nf-arrow--next');

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      slider.classList.toggle('is-start', track.scrollLeft <= 2);
      slider.classList.toggle('is-end', track.scrollLeft >= max);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Muted loops play only while on screen (GIF-style banners and slider previews).
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (video.closest('.nf-media.is-playing')) return;
      if (entry.isIntersecting) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 }) : null;

  function initVideo(video) {
    if (video.dataset.nfReady) return;
    video.dataset.nfReady = '1';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    if (observer) observer.observe(video);
  }

  // Tap a slider card: play it with sound; tap again to go back to the muted loop.
  function initToggle(btn) {
    if (btn.dataset.nfReady) return;
    btn.dataset.nfReady = '1';
    btn.addEventListener('click', function () {
      var card = btn.closest('.nf-media');
      var video = card && card.querySelector('video');
      if (!video) return;
      var playing = card.classList.contains('is-playing');
      document.querySelectorAll('.nf-media.is-playing').forEach(function (other) {
        if (other === card) return;
        other.classList.remove('is-playing');
        var v = other.querySelector('video');
        if (v) { v.muted = true; }
      });
      if (playing) {
        card.classList.remove('is-playing');
        video.muted = true;
        btn.setAttribute('aria-pressed', 'false');
      } else {
        card.classList.add('is-playing');
        video.muted = false;
        video.currentTime = 0;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.nf-slider').forEach(initSlider);
    (root || document).querySelectorAll('video.nf-video').forEach(initVideo);
    (root || document).querySelectorAll('.nf-media__toggle').forEach(initToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
